import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { savedMessagesActions } from '../../actions';
import {
  LoadMoreSavedMessagesActionPayload,
  PushMoreSavedMessagesActionPayload,
} from '../../typedefs';

export function* loadMoreSavedMessages({
  payload,
}: PayloadAction<LoadMoreSavedMessagesActionPayload>) {
  try {
    yield effects.put(savedMessagesActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: payload.nextPageUrl, direct: true },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: PushMoreSavedMessagesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(
      savedMessagesActions.pushMoreSavedMessages({
        data,
        projectId: payload.projectId,
      }),
    );
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(savedMessagesActions.stopFetching());
  }
}
